import styled from 'styled-components'

export const Preview = styled.div`
  position: relative;
  height: 0;
  width: 100%;
  transform: translate3d(0, 0, 0);

  ${({ size, framed, frameWidth = 0, frameColor }) => {
    const [width, height] = size

    const fw = 100 / (width / frameWidth)
    const fh = 100 / (height / frameWidth)

    return `
        box-shadow: 20px 20px 60px rgba(34, 42, 57, 0.2);
        padding-bottom: ${height / (width / 100)}%;

        ${framed &&
          `     
            &:before {
              content: '';
              width: ${fw * 2 + 100}%;
              height: ${fh * 2 + 100}%;
              position: absolute;
              left: -${fw}%;
              top: -${fh}%;
              background: ${frameColor};
              border-radius: 1px;
            }

            &:after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              box-shadow: inset 0 0 8px rgba(0,0,0,0.15);
              z-index: 10000;
            }
        `}
    `
  }}
`

export const Canvas = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background: white;

  display: flex;
  justify-content: center;
  align-items: center;
`

export const CanvasLayer = styled.div`
  width: 100%;
  height: auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`

export const Frame = styled.div`
  position: absolute;
  height: 0;
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;

  ${({ sizes, layout, offset, originalSizes }) => {
    const [w, h] = sizes.split(' ')
    const oh = originalSizes[1]

    const horizontal = (100 * offset) / w
    const vertical = (100 * offset) / (layout !== 'framed' ? oh : h)

    return `
        top: ${vertical}%;
        left: ${horizontal}%;
        right: ${horizontal}%;

        max-width: ${100 - horizontal * 2}%;
        ${
          layout === 'framed'
            ? `height: ${100 - vertical * 2}%;`
            : `padding-bottom: ${h / (w / 100)}%;`
        }
    `
  }}
`
